module.exports = __webpack_public_path__ + "media/images/illustrations/wave-light-2-a5d8b3b8defe5844bc96f414400a5465.svg";